import { Check, FileText, MessageSquareText, Video } from "lucide-react";

// Presentation only. These fictional profiles come from the public interview demo.
// Never mount the live interview here or imply that this illustration is a hiring decision.
export const ApexInterviewVisual = () => (
  <div
    className="apex-interview-visual"
    role="img"
    aria-label="Illustration of a structured AI interview with three questions"
  >
    <div className="apex-interview-mast">
      <Video size={16} /> AI interview <span>Illustration</span>
    </div>
    <div className="apex-waveform" aria-hidden="true">
      {[18, 34, 52, 30, 72, 94, 62, 40, 68, 44, 26, 14].map((height, index) => (
        <i key={index} style={{ height }} />
      ))}
    </div>
    <div className="apex-interview-question">What does great guest service mean to you?</div>
    <div className="apex-interview-progress">
      <span />
      <span />
      <span />
    </div>
    <div className="apex-interview-note">Structured questions. Space for their story.</div>
  </div>
);

export const ApexCompletedVisual = () => (
  <div
    className="apex-completed-visual"
    role="img"
    aria-label="Illustration of a completed interview, ready for the team to review"
  >
    <span className="apex-completed-icon">
      <Check size={28} strokeWidth={1.5} />
    </span>
    <span className="apex-visual-label">Illustration</span>
    <strong>Interview completed</strong>
    <span>Ready for your team to review.</span>
    <div>
      <FileText size={16} /> Transcript <span>·</span> <MessageSquareText size={16} /> Evidence
    </div>
  </div>
);

type ProductImageProps = {
  name: "candidate-review" | "interview-evidence" | "role-criteria" | "interview-invite";
  alt: string;
  className?: string;
};

export const ApexProductImage = ({ name, alt, className }: ProductImageProps) => (
  <img
    className={className}
    src={`/apex25/product/${name}.webp`}
    alt={alt}
    width={1200}
    height={680}
    loading="lazy"
    decoding="async"
  />
);
